<template>
  <div class="hom-page">
    <Header />
    <div class="home-content">
      <div class="lunbo">
        <el-image style="width:100%" src="img/contactMessage-banner.jpg" fit="contain"></el-image>
      </div>

      <div class="wrap">
        <div class="header">
          <div class="header-left"><span v-if="language === 'ch'">联系我们</span><span v-else>Contact Us</span></div>
          <div class="header-right"> <span v-if="language === 'ch'">首页 > 联系我们</span><span v-else>Home > Message</span> </div>
        </div>
        <div class="conten-wrap">
          <div class="left">
            <router-link to="/contactUs">
              <div class="left-item"><i class="el-icon-caret-right"> </i><span v-if="language === 'ch'">联系我们</span><span v-else>Contact Us</span></div>
            </router-link>
            <!-- <router-link to="/aboutProduct">
              <div class="left-item"><i class="el-icon-caret-right"> </i> <span v-if="language === 'ch'">留言</span><span v-else>Message</span></div>
            </router-link> -->
          </div>
          <!-- <div class="right">
            <div class="advtop-info">
              <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                <el-form-item label="姓名" prop="name">
                  <el-input v-model="ruleForm.name"></el-input>
                </el-form-item>
                <el-form-item label="电话" prop="phone">
                  <el-input v-model="ruleForm.phone" placeholder="请输入电话"></el-input>
                </el-form-item>
                <el-form-item label="需求" prop="demand">
                  <el-input v-model="ruleForm.demand" type="textarea" :autosize="{ minRows: 2, maxRows: 4}" placeholder="">
                  </el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="submitForm('ruleForm')">立即创建</el-button>
                  <el-button @click="resetForm('ruleForm')">重置</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div> -->
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from '../components/header.vue'
import Footer from '../components/footer.vue'
export default {
  components: {
    Header,
    Footer
  },
  data() {
    return {
      ruleForm: {
        name: '',
        phone: '',
        demand: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入名称', trigger: 'blur' },
        ],
        phone: [
          { required: true, message: '请输入电话', trigger: 'blur' },
        ],
        demand: [
          { required: true, message: '请输入需求', trigger: 'blur' },
        ]
      },
      language: ''
    }
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert('submit!');
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  },
  created() { },
  mounted() { 
    this.language = localStorage.getItem('curlanguage')
  }
}
</script>

<style scoped>
a {
  text-decoration: none;
}
.home-content {
  width: 1130px;
  margin: 0 auto;
  height: 1100px;
}
.lunbo {
  margin: 12px 0;
}
.wrap {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.header {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: 48px;
  line-height: 48px;
}
.header-left {
  border-bottom: 1px solid #cccccc;
  width: 25%;
}
.header-right {
  border-bottom: 1px solid #cccccc;
  width: 70%;
  color: #cccccc;
  display: flex;
  justify-content: flex-end;
  float: right;
  font-size: 14px;
}
.conten-wrap {
  margin-top: 24px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  height: 1100px;
}
.left {
  line-height: 30px;
}
.left-item {
  cursor: pointer;
}
.left-item:hover {
  color: blue;
}
.right {
  width: 70%;
}
.advtop-info {
  display: flex;
  flex-direction: column;
  width: 100%;
  line-height: 28px;
  font-size: 14px;
  color: #cccccc;
}
</style>

